// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2sz5O","item":"PaymentsMobile_item__1pCoS","label":"PaymentsMobile_label__3Ymv1","amount":"PaymentsMobile_amount__3pecD"};